export default ({ children }) => children
